var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailOpen01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29011_21260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.07227 5.62503L6.94727 8.53125C7.61395 9.03125 8.53058 9.03125 9.19727 8.53125L13.0723 5.625",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44727 5.73525C2.44727 5.28128 2.69338 4.86301 3.09021 4.64255L7.4652 2.21199C7.84277 2.00225 8.30177 2.00225 8.67933 2.21199L13.0543 4.64255C13.4511 4.86301 13.6973 5.28128 13.6973 5.73525V10.6247C13.6973 11.3151 13.1376 11.8747 12.4473 11.8747H3.69727C3.00691 11.8747 2.44727 11.3151 2.44727 10.6247V5.73525Z",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0L13 15",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29011_21260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.572266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOpen01);
export default __webpack_public_path__ + "static/media/Email_open-01.b5b528d67b7e2989e469c06cc53b51da.svg";
export { ForwardRef as ReactComponent };